export enum SectionKey {
  SUSHI = "SUSHI",
  APPETIZERS = "APPETIZERS",
  SETS = "SETS",
  DRINKS = "DRINKS",
  RESTAURANT = "RESTAURANT",
  SETS_SPECIAL = "SETS_SPECIAL",
}

export enum SubCategoriesEntries {
  SASHIMI = "SASHIMI",
  NIGIRI = "NIGIRI",
  HOSOMAKI = "HOSOMAKI",
  URAMAKI = "URAMAKI",
  URAMAKI_SPECIAL = "URAMAKI_SPECIAL",
  FUTOMAKI = "FUTOMAKI",
  SETS = "SETS",
  CHIRASHI = "CHIRASHI",
  KIDS = "KIDS",
  DRINKS = "DRINKS",
  WEGE = "WEGE",
  LUNCH = "LUNCH",
  VOUCHER = "VOUCHER",
  SETS_SPECIAL = "SETS_SPECIAL",
  OMAKASE = "OMAKASE",
  APPETIZERS = "APPETIZERS",
  SOUPS = "SOUPS",
  DESSERTS = "DESSERTS",
}

export interface Section {
  id: SectionKey;
  nameKey: string;
  categories: SubCategoriesEntries[];
  icon: string;
}

export interface CategoriesModel {
  id: string;
  name: string;
  imageUrl: string;
  backgroundImage: string;
  categoryKey: SubCategoriesEntries;
  count?: number;
}

export interface ProductModel {
  id: string;
  name: string;
  nameEn?: string;
  subName?: string;
  subNameEn?: string;
  price: number;
  count: number | null;
  category: string[];
  isSet?: boolean;
  isLunch?: boolean;
  mainCategory: SubCategoriesEntries;
  order?: number;
  descriptionToDisplay?: string;
  descriptionToDisplayEn?: string;
  onlyRestaurant?: boolean;
}
